export default {
  campanha: {
    listOptions: [],
    value: null,
    selectedList: []
  },
  nome: {
    value: '',
    required: false,
    state: null
  },
  documento: {
    value: '',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/reports/campanha/envioCampanha/search/search-form.js